module.exports = __webpack_public_path__ + "img/icon14.2664800f.png";